import * as React from 'react';
export var DEFAULT_CONTEXT = {
  vertical: false
};
export default React.createContext(DEFAULT_CONTEXT);